import React, { useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DeleteCmsCoachingCourse, patchCmsCoachingOverview } from "../../../../store/actions/cms/cmsCoaching";

const DeleteConfirmation = (props) => {
  const { id, courseId } = useParams();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    Delete_cms_coaching_course_success,
    patchCmsCoachingOverviewData,
    Delete_cms_coaching_course_loading,
    patchCmsCoachingOverviewLoading,
    delete_cms_coaching_course_failure,
    patchCmsCoachingOverviewError } = useSelector((state) => state?.cmsCoaching)


  useEffect(() => {
    if (courseId) {
      let params = {};
      params.course_id = courseId;
      if (courseId) {
        dispatch(DeleteCmsCoachingCourse(params));
      }
    } else {
      let params = {};
      params.coaching_id = id;
      params.is_delete = "true";
      if (id) {
        dispatch(patchCmsCoachingOverview(params));
      }
    }
    return () => {
      dispatch({ type: 'CLEAR_DELETE_CMS_COACHING_COURSE' })
      dispatch({ type: 'CLEAR_PATCH_CMS_COACHING_OVERVIEW' })
    }
  }, [])

  useEffect(() => {
    if (Delete_cms_coaching_course_success || patchCmsCoachingOverviewData || delete_cms_coaching_course_failure || patchCmsCoachingOverviewError) {
      setTimeout(() => {
        navigate(-1)
      }, 2000)
    }
  }, [Delete_cms_coaching_course_success || patchCmsCoachingOverviewData || delete_cms_coaching_course_failure || patchCmsCoachingOverviewError])

  return (

    <div className={"permission_denied"}>
      {(patchCmsCoachingOverviewLoading || Delete_cms_coaching_course_loading) ?
        <>
          {patchCmsCoachingOverviewLoading && <h1>Deleting Coaching...</h1>}
          {Delete_cms_coaching_course_loading && <h1>Deleting Coaching Course...</h1>}
        </>
        :
        <>
          {
            (Delete_cms_coaching_course_success || patchCmsCoachingOverviewData) &&
            <div>
              <h1>Deleted SuccessFully</h1>
              <h5>Thank You!</h5>
            </div>
          }
          {
            (delete_cms_coaching_course_failure || patchCmsCoachingOverviewError) &&
            <div className='text-danger'>
              <h1>Deletion Failed</h1>
              <h5>Please Try Again</h5>
            </div>
          }
        </>
      }
    </div>
  )
}

export default DeleteConfirmation